import React, {useState} from "react";
import {Box, Button, Columns, Form} from "react-bulma-components";
import Collapsible from "react-collapsible";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function NewRateCard({save}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();

    const [rate, setRate] = useState({
        name: "",
        day1_2_rate: 0,
        day3_6_rate: 0,
        day7_27_rate: 0,
        day_28_plus_rate: 0,
        insurance_perc: 0,
        admin_perc: 0,
        description: "",
        contact: undefined
    });

    const clear = () => {
        setRate({
            name: "",
            day1_2_rate: 0,
            day3_6_rate: 0,
            day7_27_rate: 0,
            day_28_plus_rate: 0,
            insurance_perc: 0,
            admin_perc: 0,
            description: "",
            contact: undefined
        })
    }

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const onChange = e => {
        let newRate = {...rate, [e.target.name]: e.target.value};
        setRate(newRate);
    }

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "contact",
                value: e[0]
            }
        }
        onChange(toUpdate)
    }

    const handleSave = e => {
        save(rate, () => {
            clear();
        });
    }

    return (
        <Box>
            <Collapsible
                triggerClassName={"title"}
                triggerOpenedClassName={"title"}
                trigger={"New Rate Card"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Label>Name</Form.Label>
                        <Form.Input
                            name={"name"}
                            value={rate.name}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Day 1-2 Rate</Form.Label>
                        <Form.Input
                            name={"day1_2_rate"}
                            value={rate.day1_2_rate}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Day 3-6 Rate</Form.Label>
                        <Form.Input
                            name={"day3_6_rate"}
                            value={rate.day3_6_rate}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Day 7-27 Rate</Form.Label>
                        <Form.Input
                            name={"day7_27_rate"}
                            value={rate.day7_27_rate}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Day 28+ Rate</Form.Label>
                        <Form.Input
                            name={"day_28_plus_rate"}
                            value={rate.day_28_plus_rate}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Insurance Charge (%)</Form.Label>
                        <Form.Input
                            name={"insurance_perc"}
                            value={rate.insurance_perc}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Admin Charge (%)</Form.Label>
                        <Form.Input
                            name={"admin_perc"}
                            value={rate.admin_perc}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Description</Form.Label>
                        <Form.Textarea
                            name={"description"}
                            value={rate.description}
                            onChange={onChange}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Customer</Form.Label>
                        <AsyncTypeahead
                          useCache={false}
                          id="typeahead"
                          labelKey="display_name"
                          minLength={2}
                          name={"contact"}
                          onSearch={handleSearch}
                          onChange={handleContactSelect}
                          placeholder={"Search Customer"}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          isLoading={isLoading}
                          selected={
                            rate.contact && rate.contact.id ? [rate.contact] : []
                          }
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={handleSave}
                            fullwidth
                        >
                            Create
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )



}